import React from "react";
import { Helmet } from "react-helmet";
import { Script } from "gatsby";
import { getBoolFromVar } from "@parallelpublicworks/clf-utils";

export default function Root({ children, options }) {
	const version = options.version || Math.random();
	return (
		<React.Fragment>
			<Helmet
				htmlAttributes={{
					lang: "en",
				}}
			>
				<meta
					name="viewport"
					content="minimum-scale=1, initial-scale=1, width=device-width"
				/>
				{!getBoolFromVar(process.env.CLF_WHITELABEL) && options.style && (
					<link rel="stylesheet" href={`${options.style}?v=${version}`} />
				)}
			</Helmet>
			{options.customScripts &&
				process.env.CLF_ENV === "production" &&
				options.customScripts.map((scripts) => (
					<Script key={scripts.id}>{scripts.script}</Script>
				))}
			{children}
		</React.Fragment>
	);
}
